import {
    Breadcrumb,
    Button,
    Col,
    Drawer,
    Dropdown,
    Empty,
    Form, FormInstance,
    Input,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    TimePicker,
    notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../redux/reducers";
import {
    BasicStateForListModel
} from "../models";

import {
    AndroidFilled,
    AppleFilled, CheckCircleFilled, DeleteOutlined,
    DownOutlined,
    InfoCircleOutlined,
    PlusOutlined,
    StopFilled,
    createFromIconfontCN
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
    deleteMacEnrollmentSetting,
    addOrUpdateMacEnrollmentSettingBasicInfo,
    getMacEnrollmentSetting,
    updateMacEnrollmentSettingAccountInfo,
    getMacEnrollmentSettingList
} from "../../axios/api.enroll";
import { EnrollmentSettingBasicInfo } from "./enrollment.preSetting.basicInfo";
import { EnrollmentSettingAccountInfo } from "./enrollment.preSetting.accountInfo";
import { Translation } from "react-i18next";
import { EnrollmentSettingCustomWeb } from "./enrollment.preSetting.customWebSetting";


const {Column} =Table
const { SubMenu } = Menu;
const { Item } = Form;
const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2670925_pf3sykyocl.js', // 在 iconfont.cn 上生成
});
interface stateModel extends BasicStateForListModel {
    name: string,
    current: string,
    selectTemplate: string,
    isShowTable: boolean,
    search: string,
    isShowAddForm: boolean,
    selectRow: any,
    showRightBox: boolean
    selectDevices: any[],
    currentName: string,
    dropdownVisible: any[],
    settingId:string
}
interface propsModel extends RouteComponentProps<any, any, any> {
    tokenSuccess: boolean
}
const mapStatetoProps = (state: RootStoreModel) => ({
    tokenSuccess: state.userState.tokenSuccess
});

class MacEnrollmentSetting extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "MacEnrollmentSetting",
            current: "",
            currentName: "",
            selectTemplate: "",
            isShowTable: true,
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            search: "",
            loading: false,
            data: [],
            columns: [],
            isShowAddForm: false,
            selectRow: {},
            showRightBox: false,
            selectDevices: [],
            dropdownVisible: [],
            settingId:""
        }
    }
    Init() {
        this.getList();
    }
    componentDidMount() {
        if (this.props.tokenSuccess) {
            this.Init();
        }

    }
    componentDidUpdate(prevProps: propsModel) {
        if (this.props.tokenSuccess !== prevProps.tokenSuccess) {
            this.Init();
        }
    }

    deviceHandleChange(value: any[]) {
        this.setState({ selectDevices: value });
    }
    getList(pageIndex = this.state.pageIndex,
        pageSize = this.state.pageSize) {
        var temArg = {
            pageIndex: pageIndex,
            pageSize: pageSize,
            search: this.state.search
        }
        getMacEnrollmentSettingList(temArg).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageSize: res.pageSize,
                    pageIndex: res.pageIndex,
                    loading: false,
                    totalCount: res.totalCount,
                    dropdownVisible: [],
                });
                res.dataList.forEach((item: any) => {
                    this.state.dropdownVisible.push({key: item.id, value: false});
                });
            })
    }
    templateNameUpdate = (e: any) => {
        console.log(e);
        var sele = {
            name: e.target.value,
            id: this.state.selectRow.id,
            platform: this.state.selectRow.platform,
            brand: this.state.selectRow.brand,
            status: this.state.selectRow.status,
            category: "Mac"
        }
        this.setState({ selectRow: sele })
    }

    handleMenuClick = (e: any) => {
        var currname = "";
        switch (e.key) {
            case "BasicInfo":
                currname = "基本信息";
                break;
            case "AccountInfo":
                currname = "账户设置"
                break;
            case "CustomWebSetting":
                currname = "自定义页面"
                break;
        }
        this.setState({ current: e.key, currentName: currname });
    };
    onSearch = () => {
        this.getList();

    }

    updateSetting = ()=>{
        this.setState({isShowTable : true })
    }

    updatePreSetting = (row: any) => {
        // var obj1 = {
        //     directoryType: row.directoryType,
        //     host: row.host,
        //     baseDN: row.baseDN,
        //     bindDN: row.bindDN,
        //     bindDNPassword: row.bindDNPassword
        // };
        // var obj2 = {
        //     userIdentifier: row.userIdentifier,
        //     userName: row.properyMappings?.userName,
        //     email: row.properyMappings?.email,
        //     phoneNumber: row.properyMappings?.phoneNumber,
        //     orgName: row.properyMappings?.orgName,
        //     number: row.properyMappings?.number
        // };
        // var obj3 = {
        //     name: row.name,
        //     syncFrequency: row.syncFrequency,
        //     status: row.status
        // };
        // this.formRef.current?.setFieldsValue(obj1);

        this.setState({ 
            isShowTable: false,
            selectRow: row,
            current: "BasicInfo",
            currentName: "基本信息"
            // isModify: true, 
            // settingId: row.id
        })
    }

    deletePreSetting = (id: string) => {
        deleteMacEnrollmentSetting(id).then(
            () => {
                notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                this.getList();
            },
            () => {
                notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> });
            }
        )
    }
    
    render() {
        const { 
            name, current, selectTemplate, isShowTable,data, 
            pageIndex, pageSize, totalCount, search, 
            loading, selectRow, currentName
        } = this.state;
        return (
            <Translation>{t => {
                return (
                    <div>
                        <div className="breadcrumbTop py-2">
                            <Breadcrumb>
                                <Breadcrumb.Item>{t("注册")}</Breadcrumb.Item>
                                <Breadcrumb.Item>{t("预配置")}</Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <a onClick={() => {
                                        this.setState({ 
                                            isShowTable: true, 
                                            currentName: "", 
                                            current: "",
                                            settingId: "",
                                            selectRow: {}
                                        });
                                        this.getList();
                                        this.props.history.replace("/home/enrollments/settings/apples/preEnrollment");
                                    }}>{t("注册预配置")}</a>
                                </Breadcrumb.Item>
                                {currentName?.trim() ? <Breadcrumb.Item>{t(currentName)}</Breadcrumb.Item> : null}
                            </Breadcrumb>
                        </div>
                        <Row style={{ width: "100%" }}>
                            {!isShowTable && (
                                <div className="borderBox">
                                    <Row style={{height: "36px", borderBottom: "1px solid #F1F1F1"}}>
                                        <Col span={10} style={{textAlign: "center", marginTop: "-3px"}}>
                                            <span style={{
                                                fontSize: "16px",
                                                fontWeight: 600,
                                                marginLeft: "10px",
                                            }}>{t("注册预配置")}</span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={4}>
                                            <Menu mode="inline" defaultSelectedKeys={['BasicInfo']} defaultOpenKeys={['BasicInfo']}
                                                onClick={this.handleMenuClick} selectedKeys={[current]}
                                            >
                                                <Menu.Item key="BasicInfo">
                                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                                        <span>{t("基本信息")}</span>
                                                    </div>
                                                </Menu.Item>
                                                <Menu.Item key="AccountInfo">
                                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                                        <span>{t("账户设置")}</span>
                                                    </div>
                                                </Menu.Item>
                                                <Menu.Item key="CustomWebSetting">
                                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                                        <span>{t("自定义页面")}</span>
                                                    </div>
                                                </Menu.Item>
                                            </Menu>
                                        </Col>
                                        <Col span={20}>
                                            {current === "BasicInfo" && (
                                                <EnrollmentSettingBasicInfo settingId={selectRow.id} updateSetting={this.updateSetting} ></EnrollmentSettingBasicInfo>
                                            )}
                                            {current === "AccountInfo" && (
                                                <EnrollmentSettingAccountInfo  settingId={selectRow.id} updateSetting={this.updateSetting}></EnrollmentSettingAccountInfo>
                                            )}
                                            {current === "CustomWebSetting" && (
                                                <EnrollmentSettingCustomWeb  settingId={selectRow.id} updateSetting={this.updateSetting}></EnrollmentSettingCustomWeb>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            )}
                            {isShowTable && (
                                <>
                                    <div className="borderBox">
                                        <Row  className="mb-3">
                                            <Col > 
                                            {t("注册预配置名称")}:
                                            <Input placeholder="" value={search}
                                            style={{ width: "200px", marginLeft: 10 }}
                                                onChange={(e) => this.setState({ search: e.target.value })} /></Col>
                                            <Col offset={1}>
                                                <Button type="primary" onClick={() => { this.onSearch(); }}>
                                                    {t("查询")}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="borderBox">
                                        <Row>
                                            <span style={{color:"grey"}}><InfoCircleOutlined /> {t("存在多条有效配置时，系统将采用最近更新的一条")}</span>
                                            <Col className="ms-auto" style={{ marginBottom: 8 }}>  <Button type="primary"
                                                onClick={() => { this.setState({ isShowTable: false, current: "BasicInfo", currentName:"基本信息" }) }}><PlusOutlined />{t("添加")}</Button></Col>
                                        </Row>
                                        <Row  >
                                            <Col span={24}>
                                                <Table 
                                                    size="middle" 
                                                    dataSource={data} 
                                                    rowKey={recored => recored.id} 
                                                    style={{ width: "100%", minHeight: 300 }} 
                                                    pagination={false}
                                                    locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                                >
                                                    <Column
                                                        title={t("注册预配置名称")}
                                                        key="name"
                                                        dataIndex="name"
                                                    ></Column>
                                                    <Column
                                                        title={t("创建时间")}
                                                        key="createdTime"
                                                        dataIndex="createdTime"
                                                    ></Column>
                                                    <Column
                                                        title={t("更新时间")}
                                                        key="updatedTime"
                                                        dataIndex="updatedTime"
                                                    ></Column>
                                                    <Column key="status" dataIndex="status" title={t("状态")}
                                                        render={(v) => (
                                                        <> 
                                                            {v=="Active"&&(
                                                                <span><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                                                            )}
                                                            {v=="Disabled"&&(
                                                                <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                                                            )}
                                                        </>
                                                        )}
                                                    ></Column>
                                                    <Column
                                                        title={t("操作")}
                                                        key="id"
                                                        dataIndex="id"
                                                        align="center"
                                                        render={(v, row: any, index) => {
                                                            return (
                                                                <Space size={8}>
                                                                    <Button type="link" block onClick={
                                                                        () => {
                                                                            this.updatePreSetting(row);
                                                                        }
                                                                    }>{t("编辑")}
                                                                    </Button>
                                                                    <Popconfirm
                                                                        title={`${t("确认删除")}？`}
                                                                        onConfirm={() => {
                                                                            this.deletePreSetting(row.id);
                                                                        }}
                                                                        okText={t("确认")}
                                                                        cancelText={t("取消")}
                                                                    >
                                                                        <Button type="link" block>{t("删除")}</Button>
                                                                    </Popconfirm>
                                                                </Space>
                                                            )
                                                        }}></Column>
                                                </Table>
                                                <Pagination
                                                    style={{ textAlign: "right", marginTop: "20px" }}
                                                    pageSize={pageSize}
                                                    current={pageIndex}
                                                    total={totalCount}
                                                    showTotal={(total, range) =>
                                                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                                                    }
                                                    onChange={(page, pageSize) => {
                                                        this.getList(page, pageSize);
                                                    }}
                                                    onShowSizeChange={(current, size) => this.getList(current, size)}
                                                ></Pagination>
                                            </Col>
                                        </Row>
                                    </div>
                                </>
                            )}
                        </Row>
                    </div>
                )
            }}</Translation>
        )
    }
}
export default connect(mapStatetoProps, {})(MacEnrollmentSetting);